export const saveFailureFacets = (recordedError: NonNullable<unknown>) => {
    const error = recordedError as { status?: number; response?: Record<string, any> } & Record<string, any>;
    const body = error.response ?? error;
    const facets = body.error;

    return {
        ...(error.status && { httpStatus: error.status }),
        ...(body.traceId && { traceId: body.traceId }),
        ...(typeof facets === 'object' && facets)
    };
};
